import { QuestionDataById, QuestionNamesById } from './types';

type HydrateQuestionData = {
  questionsById: QuestionDataById;
  questionNamesById: QuestionNamesById;
};

export const hydrateQuestionData = ({ questionsById, questionNamesById }: HydrateQuestionData) => {
  // directly mutate questionsById to add question ids and names
  Object.keys(questionsById).forEach((key) => {
    questionsById[key].questionId = parseFloat(key);
    questionsById[key].questionName = questionNamesById[parseFloat(key)];

    questionsById[key].lists?.forEach((item) => {
      item.questionId = parseFloat(key);
    });
  });
};
